import main from '../scss/main.scss';
import Mmenu from 'mmenu-js';
import { createPopper } from '@popperjs/core';
import 'bootstrap';

const fancybox = require('@fancyapps/fancybox');

window.bootstrap = require('bootstrap');

const root = document.querySelector('html');
const body = document.querySelector('body');

// get the sticky element
const header = document.querySelector('.main-header');

const observer = new IntersectionObserver(([e]) => e.target.classList.toggle('sticky', e.intersectionRatio < 1), { threshold: [1] });

observer.observe(header);

// Adding class on scroll

const throttleTime = 250;
const throttle = (callback, time) => {
  setTimeout(() => {
    callback();
  }, time);
};

const scrollNav = () => {
  if (window.scrollY >= 10) {
    body.classList.add('sticky');
  } else {
    body.classList.remove('sticky');
  }
};

let scrollpos = window.scrollY;

const scrollBtn = document.querySelector('.btn-scroll-top');
const scrollChange = 900;

const add_class_on_scroll = () => scrollBtn.classList.add('show');
const remove_class_on_scroll = () => scrollBtn.classList.remove('show');

const toggleScrollBtn = () => {
  scrollpos = window.scrollY;

  if (scrollpos >= scrollChange) {
    add_class_on_scroll();
  } else {
    remove_class_on_scroll();
  }
};

window.addEventListener('scroll', () => {
  throttle(scrollNav, throttleTime);
  throttle(toggleScrollBtn, throttleTime);
});

document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu initialization
  new Mmenu('#main-menu', {
    // options
  }, {
    // configuration
    offCanvas: {
      clone: true, screenReader: {
        closeMenu: 'Zamknij menu', openMenu: 'Otwórz menu'
      }, page: {
        selector: '#app'
      }
    }
  });

  // Contrast switching

  const highContrast = document.querySelector('.high-contrast-btn');

  if (highContrast) {
    highContrast.addEventListener('click', function(el) {
      let contrastVal = el.target.getAttribute('data-contrast');
      let contrastLink = document.querySelector('.contrast-link');
      document.cookie = 'contrast=' + contrastVal + '; path=/';
      //contrastTooltip.dispose();
      if (contrastLink && root.dataset.contrast !== 'default') {
        highContrast.setAttribute('data-contrast', 'black-on-yellow');
        root.dataset.contrast = contrastVal;
        if (contrastLink) {
          contrastLink.parentNode.removeChild(contrastLink);
          highContrast.setAttribute('aria-label', 'Włącz wersję kontrastową');
          highContrast.setAttribute('title', 'Włącz wersję kontrastową');
          highContrast.setAttribute('data-bs-tooltip', 'Włącz wersję kontrastową');
        }
      } else {
        root.dataset.contrast = contrastVal;
        highContrast.setAttribute('data-contrast', 'default');
        if (contrastVal !== 'default') {
          let contrastLinkAppend = document.createElement('link');
          contrastLinkAppend.classList.add('contrast-link');
          contrastLinkAppend.setAttribute('rel', 'stylesheet');
          contrastLinkAppend.href = templateURL + '/dist/' + contrastVal + '.css';
          document.head.appendChild(contrastLinkAppend);
          highContrast.setAttribute('aria-label', 'Wyłącz wersję kontrastową');
          highContrast.setAttribute('title', 'Wyłącz wersję kontrastową');
          highContrast.setAttribute('data-bs-tooltip', 'Wyłącz wersję kontrastową');
        } else {
          if (contrastLink) {
            contrastLink.remove();
          }
        }
      }
      //contrastTooltip = new bootstrap.Tooltip(highContrast);
    });
  }
  if (highContrast) {
    //var contrastTooltip = new bootstrap.Tooltip(highContrast);
  }

  const checkHighContrast = root.dataset.contrast;
  let contrastVal = root.dataset.contrast;

  if (checkHighContrast == 'black-on-yellow') {
    let contrastLinkAppend = document.createElement('link');
    contrastLinkAppend.classList.add('contrast-link');
    contrastLinkAppend.setAttribute('rel', 'stylesheet');
    contrastLinkAppend.href = templateURL + '/dist/' + contrastVal + '.css';
    document.head.appendChild(contrastLinkAppend);
    highContrast?.setAttribute('data-contrast', 'default');
  }

  // Font size changing

  const fontSizeBtns = document.querySelectorAll('.font-size-btn');

  if (fontSizeBtns) {
    fontSizeBtns.forEach((btn) => {
      btn.addEventListener('click', (el) => {
        let fontSizeVal = el.target.getAttribute('data-font-size');
        root.dataset.fontSize = fontSizeVal;
        document.cookie = 'font-size=' + fontSizeVal + '; path=/';
      });
    });
  }

  // Adds 'Opens in new window' tooltip info

  const targetBlankLink = document.querySelectorAll('[target="_blank"]');
  if (targetBlankLink) {
    targetBlankLink.forEach((el) => {
      el.title = 'Otwiera nowe okno';
      el.setAttribute('data-bs-toggle', 'tooltip');
    });
  }

  // Makes whole card clickable
  const cardClickable = document.querySelectorAll('.card-clickable');
  if (cardClickable) {
    cardClickable.forEach((card) => {
      card.addEventListener('click', (e) => {
        const currTarget = e.currentTarget;
        const currLink = currTarget.querySelector('.card-link');
        if (currLink) {
          currLink.click();
        }
      });
    });
  }

  // Initialize tooltips
  // var tooltipTriggerList = [].slice.call(
  //   document.querySelectorAll('[data-bs-toggle="tooltip"]')
  // );
  // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  //   return new bootstrap.Tooltip(tooltipTriggerEl, {
  //     //container: 'body',
  //     //trigger: 'hover',
  //   });
  // });

  // document click listener
  const mainSearch = document.querySelector('.search__wrapper');
  const searchField = mainSearch.querySelector('.main-search-field');
  const tabbableElements = mainSearch.querySelectorAll('.tabbable');
  const searchBtn = document.querySelector('.search-toggle-btn');

  document.addEventListener('click', (e) => {
    // Search toggle
    if (e.target.classList.contains('search-toggle-btn')) {
      if (mainSearch.classList.contains('show')) {
        mainSearch.classList.remove('show');
        tabbableElements.forEach((el) => el.setAttribute('tabindex', -1));
        e.target.setAttribute('aria-pressed', false);
      } else {
        mainSearch.classList.add('show');
        tabbableElements.forEach((el) => el.setAttribute('tabindex', 0));
        e.target.setAttribute('aria-pressed', true);
        searchField.focus();
      }
    } else {
      if (e.target.classList.contains('main-search-field') != true) {
        mainSearch.classList.remove('show');
        tabbableElements.forEach((el) => el.setAttribute('tabindex', -1));
        searchBtn.setAttribute('aria-pressed', false);
      }
    }

    // GDPR/cookie dialog aria-hidden fix
    const settingsBtn = document.querySelector('.cli_settings_button');
    const cliModal = document.querySelector('.cli-modal');

    if (e.target.classList.contains('cli_settings_button') && cliModal.getAttribute('aria-hidden') == 'true') {
      cliModal.setAttribute('aria-hidden', 'false');
    } else {
      cliModal.setAttribute('aria-hidden', 'true');
    }
  });

  // Fix role=dialog for nav wcag moaning
  const navRoleDialogs = document.querySelectorAll('nav[role="dialog"]');

  if (navRoleDialogs) {
    navRoleDialogs.forEach((el) => {
      el.setAttribute('role', 'navigation');
    });
  }

  // // Fix role=dialog for nav wcag moaning
  const navRoleAriaModals = document.querySelectorAll('nav[aria-modal="true"]');

  if (navRoleAriaModals) {
    navRoleAriaModals.forEach((el) => {
      el.removeAttribute('aria-modal');
    });
  }

  /* Cookies Policy - WCAG Fix */
  const cookiesSettingsBtn = document.querySelector('.cli_settings_button');
  if (cookiesSettingsBtn) {
    cookiesSettingsBtn.setAttribute('tabIndex', '0');
    cookiesSettingsBtn.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        e.target.click();
        document.querySelector('.cli-modal-close').focus();
      }
    });
  }

  const cookiesActionBtn = document.querySelector('.cli_action_button');
  if (cookiesActionBtn) {
    cookiesActionBtn.setAttribute('tabIndex', '0');
  }

  // let tabLink = document.querySelectorAll('.cli-tab-header a');
  // tabLink = Array.from(tabLink);
  // if (tabLink) {
  //   tabLink.forEach((link) => {
  //     link.addEventListener('keyup', (e) => {
  //       if (e.key === 'Enter') {
  //         e.target.click();
  //       }
  //     });
  //   });
  // }

  const cookieCheckboxes = document.querySelectorAll('.cli-user-preference-checkbox');
  if (cookieCheckboxes) {
    cookieCheckboxes.forEach((el) => {
      el.addEventListener('keyup', (e) => {
        if (e.key === 'Enter') {
          e.target.click();
        }
      });
    });
  }

  // const cookiebar = document.querySelector('.cli-bar-container');

  // if (cookiebar) {
  //   cookiebar.parentElement.outerHTML =
  //     '<div>' + cookiebar.parentElement.innerHTML + '</div>';
  // }

  // const links = document.querySelectorAll('.gde-text a');
  // for (var i = 0; i < links.length; i++) {
  //   let name = links[i].getAttribute('href');
  //   let tmp_name = name.split('/');
  //   name = '&nbsp;<span class="">' + tmp_name[7] + '</span>&nbsp;';
  //   let link_text = links[i].textContent;
  //   let tmp_link_text = link_text.split(' (');
  //   let new_text = tmp_link_text[0] + ' ' + name + '(' + tmp_link_text[1];
  //   links[i].innerHTML = new_text;
  // }

  const cookieBar = document.querySelector('#cookie-law-info-bar');
  const cookieBarAgain = document.querySelector('#cookie-law-info-again');
  const footer = document.querySelector('footer');
  const cookieBarWrapper = document.createElement('section');
  const cookieBarWrapperHeading = document.createElement('h2');
  cookieBarWrapperHeading.classList.add('d-none');
  cookieBarWrapperHeading.setAttribute('aria-hidden', 'true');
  cookieBarWrapperHeading.textContent = 'Informacja o plikach cookie';
  cookieBarWrapper.setAttribute('aria-label', 'Informaca o plikach cookie');

  if (cookieBar) {
    cookieBarWrapper.appendChild(cookieBarWrapperHeading);
    cookieBarWrapper.appendChild(cookieBar);
    body.appendChild(cookieBarWrapper);

    // GDPR/cookie div in span fix
    const gdprWrapper = document.createElement('div');
    const spanParent = document.querySelector('#cookie-law-info-bar > span');
    gdprWrapper.classList.add('gdpr-wrapper');
    gdprWrapper.innerHTML = spanParent.innerHTML;
    cookieBar.appendChild(gdprWrapper);
    spanParent.remove();
  }
  if (cookieBarAgain) {
    footer.appendChild(cookieBarAgain);
  }

  const cliModal = document.querySelector('.cli-modal');

  if (cliModal) {
    const modalTitle = cliModal.querySelector('.cli-privacy-overview h4');
    modalTitle.outerHTML = '<h3>' + modalTitle.textContent + '</h3>';
  }

  /* add fancybox into gallery images */
  const galleryItems = document.querySelectorAll('.wp-block-gallery a');
  const imageItems = Array.from(document.querySelectorAll('figure.wp-block-image a')).filter((el) => !el.closest('.wp-block-gallery'));

  if (galleryItems) {
    galleryItems.forEach((elem) => {
      elem.setAttribute('data-fancybox', 'gallery');
    });
  }

  const galleryElements = document.querySelectorAll('.gallery a');
  if (galleryElements) {
    galleryElements.forEach((elem) => {
      elem.setAttribute('data-fancybox', 'gallery');
    });
  }

  if (imageItems) {
    imageItems.forEach((elem) => {
      elem.setAttribute('data-fancybox', 'data-fancybox');
    });
  }

  jQuery('[data-fancybox]').fancybox({
    afterLoad: function(instance, current) {
      current.$image.attr('alt', current.opts.$orig.find('img').attr('alt'));
      const galleryContainer = document.querySelector('.fancybox-container');
      galleryContainer.setAttribute('aria-label', 'Przegląd zdjęć');
    }, buttons: ['close'], autofocus: true, lang: 'pl', i18n: {
      pl: {
        CLOSE: 'Zamknij',
        NEXT: 'Następny',
        PREV: 'Poprzedni',
        ERROR: 'Wystąpił błąd podczas ładowania zawartości.<br>Spróbuj ponownie.',
        PLAY_START: 'Włącz automatyczne przeglądanie',
        PLAY_STOP: 'Zatrzymaj automatyczne przeglądanie',
        FULL_SCREEN: 'Pełny ekran',
        THUMBS: 'Miniatury',
        DOWNLOAD: 'Pobierz',
        SHARE: 'Udostępnij',
        ZOOM: 'Przybliż'
      }
    }
  });

  // Slider

  const sliderSection = document.querySelector('.n2-section-smartslider');

  if (sliderSection) {
    sliderSection.removeAttribute('tabindex');
  }

  // Map

  const map = document.querySelector('#map');

  if (map) {
    map.removeAttribute('tabindex');
  }

  // BIP

  const bipSearch = document.querySelector('.bip-search');

  if (bipSearch) {
    bipSearch.setAttribute('aria-label', 'Wyszukiwarka BIP');
    bipSearch
      .querySelector('input[type="search"]')
      .classList.add('form-control');
    bipSearch
      .querySelector('input[type="submit"]')
      .classList.add('btn', 'btn-primary');
  }

  // Figure caption wcag fix

  const figureImages = document.querySelectorAll('figure.wp-block-image');

  if (figureImages) {
    figureImages.forEach((image) => {
      const noCaption = image.querySelector('figcaption') === null;
      if (noCaption) {
        const caption = document.createElement('figcaption');
        caption.textContent = 'Obrazek';
        caption.classList.add('visually-hidden');
        image.appendChild(caption);
      }
    });
  }

  const pageType = document.querySelector('.searchandfilter .postform');

  if (pageType) {
    const optionsTypes = pageType.getElementsByTagName('option');
    optionsTypes[0].innerText = 'Wszystkie';
  }

  const searchFilterPhrase = document.querySelector('.searchandfilter [name="ofsearch"]');

  if (searchFilterPhrase) {
    searchFilterPhrase.classList.add('form-control');
    searchFilterPhrase.id = 'ofsearch';
    const sFPHeading = searchFilterPhrase.parentElement.querySelector('h4');
    const searchFilterPhraseLabel = document.createElement('label');
    searchFilterPhraseLabel.textContent = sFPHeading.textContent;
    searchFilterPhraseLabel.setAttribute('for', 'ofsearch');
    searchFilterPhraseLabel.classList.add('form-label');
    sFPHeading.remove();
    searchFilterPhrase.parentElement.insertBefore(searchFilterPhraseLabel, searchFilterPhrase);
  }

  const searchFilterType = document.querySelector('.searchandfilter [name="ofpost_types"]');

  if (searchFilterType) {
    searchFilterType.classList.add('form-select');
    searchFilterType.id = 'ofpost_types';
    const sFTHeading = searchFilterType.parentElement.querySelector('h4');
    const searchFilterTypeLabel = document.createElement('label');
    searchFilterTypeLabel.textContent = sFTHeading.textContent;
    searchFilterTypeLabel.setAttribute('for', 'ofpost_types');
    searchFilterTypeLabel.classList.add('form-label');
    sFTHeading.remove();
    searchFilterType.parentElement.insertBefore(searchFilterTypeLabel, searchFilterType);
  }

  const searchFilterDates = document.querySelectorAll('.searchandfilter [type="date"]');

  if (searchFilterDates.length > 0) {
    let searchFilterDateLabel;
    searchFilterDates.forEach((date, index) => {
      date.classList.add('form-control');
      date.id = `date-${index}`;
      searchFilterDateLabel = document.createElement('label');
      searchFilterDateLabel.setAttribute('for', `date-${index}`);
      searchFilterDateLabel.classList.add('form-label', `date-${index}`);
      date.parentElement.insertBefore(searchFilterDateLabel, date);
    });
    searchFilterDates[0].parentElement.querySelector('h4').remove();
    const dateFrom = document.querySelector('.date-0');
    dateFrom.textContent = 'Data od';
    const dateTo = document.querySelector('.date-1');
    dateTo.textContent = 'Data do';
  }

  const searchFilterSubmitBtn = document.querySelector('.searchandfilter [type="submit"]');

  if (searchFilterSubmitBtn) {
    searchFilterSubmitBtn.classList.add('btn', 'btn-primary');
  }

  // Main menu remove focus after click
  const mainMenu = document.querySelector('#main-nav');

  if (mainMenu) {
    const menuItems = mainMenu.querySelectorAll('a');
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener('mouseleave', (e) => {
        e.target.blur();
      });
    });
  }


});
window.addEventListener('load', function() {
  const reCaptchaTextarea = document.getElementsByClassName('g-recaptcha-response');
  if (reCaptchaTextarea) {
    const reCaptchaTextareaNode = document.querySelector('.g-recaptcha-response');
    const reCaptchaTextareaID = reCaptchaTextarea[0].id;
    const labelCaptchaTextarea = document.createElement('label');
    labelCaptchaTextarea.setAttribute('for', reCaptchaTextareaID);
    labelCaptchaTextarea.innerText = 'Google reCaptcha response';
    const parentDiv = document.querySelector('.grecaptcha-badge');
    parentDiv.insertBefore(labelCaptchaTextarea, reCaptchaTextareaNode);
  }
});
